<template>
  <el-dialog
    :visible="true"
    :show-close="false"
    @close="abortAction"
  >
    <ContentHeader
      slot="title"
      :title="modalTitle"
    />
    <div class="table-wrapper">
      <el-table
        class="width-100"
        :data="testReports"
        border
      >
        <el-table-column
          prop="date"
          :label="$t('filters.updatedAt')"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.date | date('DD/MM/YYYY') }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          :label="$t('filters.status')"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.revision > 0">
              {{
                $t('enums.reportStatuses.finalRevision', {
                  revision: scope.row.revision,
                })
              }}
            </span>
            <span v-else-if="scope.row.revision == 0">
              {{
                $t('enums.reportStatuses.final', {
                  revision: scope.row.revision,
                })
              }}
            </span>
            <span v-else>
              {{ $t(`enums.reportStatuses.draft`) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('filters.actions')">
          <template slot-scope="scope">
            <TableActions
              :configuration="{ buttons }"
              :row="scope.row"
              @actionClick="(button) => handleButtonClick(button, scope.row)"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
  import fileSaver from 'file-saver';

  import { samplesApi } from '@/api';
  import ContentHeader from '@/components/ContentHeader.vue';
  import TableActions from '@/components/TableActions.vue';

  export default {
    name: 'DownloadTestReports',
    components: {
      ContentHeader,
      TableActions,
    },
    props: {
      sample: { type: Object, required: true },
    },
    data() {
      return {
        testReports: [],
        buttons: [
          {
            name: 'downloadTestReport',
            icon: 'fas fa-file-download',
          },
        ],
      };
    },
    computed: {
      modalTitle() {
        return `${this.$t('analysesStatusManagement.testReports.title')} - ${
          this.sample.labSampleCode
        }`;
      },
    },
    methods: {
      abortAction() {
        this.$emit('dialogClose', { success: false });
      },
      handleButtonClick(button, row) {
        switch (button) {
          case 'downloadTestReport':
          default:
            this.downloadTestReport(row);
            break;
        }
      },
      async downloadTestReport(row) {
        try {
          const response = await samplesApi.getSampleReport(
            this.sample.labSampleId,
            row.id
          );
          const revision = row.revision > 0 ? `-rev-${row.revision}` : '';
          fileSaver.saveAs(
            response.data,
            `sample-report-${row.reportCode}${revision}.pdf`
          );
        } catch (error) {
          this.$notify({
            showClose: true,
            type: 'error',
            message: error.response.data.error.message,
          });
        }
      },
    },
    async created() {
      try {
        const response = await samplesApi.getSampleReports(this.sample.id);
        this.testReports = response.data;
      } catch (error) {
        this.$notify({
          showClose: true,
          type: 'error',
          message: error.response.data.error.message,
        });
      }
    },
  };
</script>
